import { ManufacturingLifecycleStatus } from './manufacturing-lifecycle-status.js';
/** A work order production hasn't started: the ones a Pick MO and Start's batch moves may still touch. */
export const WORK_ORDER_NOT_STARTED_STATUS_IDS = [
    ManufacturingLifecycleStatus.ISSUED,
    ManufacturingLifecycleStatus.PICK,
];
//# sourceMappingURL=work-order-not-started-status-ids.js.map